var map = {
	"./404.svg": 94235,
	"./arrow-left.svg": 85234,
	"./arrow-right.svg": 85353,
	"./book.svg": 23914,
	"./bug.svg": 92813,
	"./chart.svg": 13751,
	"./checkbox-checked.svg": 48842,
	"./checkbox.svg": 75742,
	"./clipboard.svg": 96889,
	"./close.svg": 98179,
	"./comment.svg": 83348,
	"./component.svg": 10250,
	"./copy.svg": 78838,
	"./dashboard.svg": 4679,
	"./documentation.svg": 23397,
	"./download.svg": 15253,
	"./drag.svg": 28715,
	"./edit.svg": 95869,
	"./edit2.svg": 68629,
	"./edit3.svg": 12372,
	"./education.svg": 3937,
	"./email.svg": 39083,
	"./example.svg": 21649,
	"./excel.svg": 42474,
	"./exit-fullscreen.svg": 54861,
	"./eye-open.svg": 12429,
	"./eye.svg": 95628,
	"./form.svg": 3771,
	"./fullscreen.svg": 6638,
	"./gou.svg": 10516,
	"./guide.svg": 47987,
	"./icon.svg": 92814,
	"./info.svg": 47061,
	"./international.svg": 5091,
	"./language.svg": 5247,
	"./link.svg": 81445,
	"./list.svg": 99161,
	"./location.svg": 80676,
	"./lock.svg": 52636,
	"./message.svg": 38166,
	"./minus.svg": 93331,
	"./money.svg": 49659,
	"./nested.svg": 85016,
	"./password.svg": 39902,
	"./pdf.svg": 38001,
	"./people.svg": 34952,
	"./peoples.svg": 46779,
	"./plus-fill.svg": 26289,
	"./praise.svg": 5973,
	"./qq.svg": 75951,
	"./setting.svg": 62419,
	"./share.svg": 85702,
	"./shopping.svg": 65697,
	"./size.svg": 88334,
	"./skill.svg": 92160,
	"./star.svg": 48637,
	"./tab.svg": 94598,
	"./table.svg": 54383,
	"./theme.svg": 88972,
	"./time.svg": 61830,
	"./trash.svg": 18717,
	"./tree-table.svg": 41622,
	"./tree.svg": 92701,
	"./user.svg": 68848,
	"./wechat.svg": 80719,
	"./zip.svg": 71902
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72922;